export const API_KEY = "AIzaSyCeh7pOVQbPZ4qLPXOCmtw-9wd5ukOHf7w";
export default API_KEY;
